module.exports = {
	categories: state => state.categories,
	loadedCategory: ({ loadedCategories }) => slug =>
		loadedCategories && loadedCategories[slug],
	selectedCategory: ({ selectedCategory }, { loadedCategory }) =>
		loadedCategory(selectedCategory),
	documents: state => state.documents,
	permissionGroups: ({ permissionGroups }) =>
		(permissionGroups || []).map(({ id, name, description }) => {
			if (description) {
				name = `${name} - ${description}`;
			}

			return {
				id,
				name
			};
		}),
	selectedDocument: (state, { selectedCategory }) => id => {
		let documents = state.documents;

		if (selectedCategory) {
			documents = selectedCategory.documents;
		}

		return documents && documents.find(document => document.id == +id);
	}
};
